export enum TerminalProvider {
    Euroset = 'euroset',
    Qps = 'qps',
    Uzcard = 'uzcard',
}
